module.exports = __webpack_public_path__ + "img/bg-404.c56c5621.png";